var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9277_72281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1914 -0.187012H43.9195V16.7151L42.349 19.1366L43.9195 21.2918V31.1231H12.1914V15.1896L13.1729 14.0757L12.1914 13.0102V-0.187012Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3516 21.631V16.7153H23.6258L24.1917 17.4433L24.7763 16.7153H43.9205V21.292C43.9205 21.292 43.4199 21.6261 42.8408 21.631H32.2403L31.6023 20.8561V21.631H29.5116V20.3082C29.5116 20.3082 29.226 20.4929 28.6086 20.4929H27.897V21.631H24.7315L24.1665 20.8874L23.5927 21.631H18.3516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1914 13.0102L13.3808 10.2739H15.4377L16.1126 11.8067V10.2739H18.6695L19.0713 11.3818L19.4609 10.2739H30.9387V10.8309C30.9387 10.8309 31.5421 10.2739 32.5337 10.2739L36.2578 10.2868L36.9212 11.7995V10.2739H39.0609L39.6498 11.1429V10.2739H41.8092V15.1896H39.6498L39.0854 14.3178V15.1896H35.9417L35.6255 14.4147H34.7804L34.4694 15.1896H32.3374C31.4841 15.1896 30.9387 14.644 30.9387 14.644V15.1896H27.7242L27.0862 14.4147V15.1896H15.1329L14.817 14.4147H13.9746L13.6609 15.1896H12.1914V13.0102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7995 10.8794L12.1953 14.5601H13.2397L13.5357 13.823H15.2565L15.5509 14.5601H16.6184L15.0157 10.8794H13.7995ZM14.393 11.736L14.9175 13.0239H13.867L14.393 11.736Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7305 14.5601V10.8794L18.2146 10.8848L19.0779 13.2579L19.9205 10.8794H21.3928V14.5601H20.4603V11.848L19.4719 14.5601H18.6541L17.6629 11.848V14.5601H16.7305Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 14.5601V10.8794H25.074V11.7027H22.9735V12.3323H25.0249V13.1072H22.9735V13.761H25.074V14.5601H22.0312Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6152 10.8794V14.5601H26.5477V13.2525H26.9403L28.0583 14.5601H29.1978L27.9709 13.204C28.4745 13.1621 28.9939 12.7356 28.9939 12.0735C28.9939 11.299 28.3778 10.8794 27.6903 10.8794H25.6152ZM26.5477 11.7027H27.6136C27.8693 11.7027 28.0553 11.9001 28.0553 12.0901C28.0553 12.3347 27.8143 12.4776 27.6274 12.4776H26.5477V11.7027Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3232 14.5601H29.3711V10.8794H30.3232V14.5601Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5829 14.5601H32.3774C31.383 14.5601 30.7793 13.787 30.7793 12.7349C30.7793 11.6567 31.3763 10.8794 32.6319 10.8794H33.6626V11.7511H32.5943C32.0845 11.7511 31.724 12.1437 31.724 12.744C31.724 13.4568 32.1362 13.7561 32.7301 13.7561H32.9755L32.5829 14.5601Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.612 10.8794L33.0078 14.5601H34.0522L34.3482 13.823H36.069L36.3634 14.5601H37.4308L35.8282 10.8794H34.612ZM35.2055 11.736L35.73 13.0239H34.6795L35.2055 11.736Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5391 14.5601V10.8794H38.7246L40.2383 13.1919V10.8794H41.1707V14.5601H40.0236L38.4715 12.187V14.5601H37.5391Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9883 21.001V17.3203H22.031V18.1436H19.9306V18.7732H21.982V19.5481H19.9306V20.2019H22.031V21.001H18.9883Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8984 21.001V17.3203H36.9412V18.1436H34.8407V18.7732H36.8823V19.5481H34.8407V20.2019H36.9412V21.001H33.8984Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1486 21.001L23.6301 19.1834L22.1133 17.3203H23.2881L24.1914 18.472L25.0978 17.3203H26.2265L24.7297 19.1607L26.2139 21.001H25.0393L24.1622 19.8674L23.3065 21.001H22.1486Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3242 17.3213V21.002H27.2812V19.8397H28.2627C29.0933 19.8397 29.7228 19.4049 29.7228 18.5593C29.7228 17.8588 29.229 17.3213 28.3839 17.3213H26.3242ZM27.2812 18.1537H28.3149C28.5832 18.1537 28.775 18.316 28.775 18.5774C28.775 18.8231 28.5842 19.0012 28.3118 19.0012H27.2812V18.1537Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1289 17.3203V21.001H31.0614V19.6934H31.454L32.572 21.001H33.7115L32.4846 19.645C32.9881 19.603 33.5075 19.1765 33.5075 18.5144C33.5075 17.7399 32.8915 17.3203 32.2039 17.3203H30.1289ZM31.0614 18.1436H32.1272C32.3829 18.1436 32.5689 18.341 32.5689 18.5311C32.5689 18.7756 32.3279 18.9185 32.1411 18.9185H31.0614V18.1436Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3723 21.001V20.2019H39.2384C39.5146 20.2019 39.6341 20.0547 39.6341 19.8932C39.6341 19.7384 39.5149 19.582 39.2384 19.582H38.3952C37.6621 19.582 37.2539 19.1413 37.2539 18.4796C37.2539 17.8894 37.6278 17.3203 38.717 17.3203H40.5328L40.1402 18.1485H38.5698C38.2696 18.1485 38.1772 18.3039 38.1772 18.4524C38.1772 18.605 38.2914 18.7732 38.5207 18.7732H39.4041C40.2212 18.7732 40.5758 19.2306 40.5758 19.8296C40.5758 20.4736 40.1807 21.001 39.3596 21.001H37.3723Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7961 21.001V20.2019H42.6623C42.9384 20.2019 43.058 20.0547 43.058 19.8932C43.058 19.7384 42.9388 19.582 42.6623 19.582H41.819C41.086 19.582 40.6777 19.1413 40.6777 18.4796C40.6777 17.8894 41.0516 17.3203 42.1408 17.3203H43.9567L43.5641 18.1485H41.9936C41.6934 18.1485 41.601 18.3039 41.601 18.4524C41.601 18.605 41.7152 18.7732 41.9445 18.7732H42.8279C43.645 18.7732 43.9996 19.2306 43.9996 19.8296C43.9996 20.4736 43.6045 21.001 42.7834 21.001H40.7961Z",
    fill: "#016FD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9277_72281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/AMEX.85e319be7e184dde50634546669d83b3.svg";
export { ForwardRef as ReactComponent };